import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

var DLog = function () {
  function DLog() {
    _classCallCheck(this, DLog);

    this.level = 2;
  }

  _createClass(DLog, [{
    key: "error",
    value: function error(msg) {
      if (this.level > 0) {
        console.error(msg);
      }
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      if (this.level > 1) {
        console.warn(msg);
      }
    }
  }, {
    key: "info",
    value: function info(msg) {
      if (this.level > 2) {
        console.log("[info] " + msg);
      }
    }
  }, {
    key: "debug",
    value: function debug(msg) {
      if (this.level > 3) {
        console.log("[debug] " + msg);
      }
    }
  }]);

  return DLog;
}();

export default DLog;
;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/DLog.js
// module id = 183
// module chunks = 0